<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord(params.id)"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord(params.id)"
    />

    <!-- <span class="feather-icon select-none relative switch-publish">
      <vs-switch v-model="params.data.IsPublished">
      
      </vs-switch>


    </span>-->
  </div>
</template>

<script>
// import axios from "@/axios.js";
import con from "@/firebase/firebaseInit.ts";

// import ls from "@/common/localStorage";
// var cn = ls.getSessionEventCollectionName();
// var Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
// var Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
// var attendeeRef = con.eventDB
//   .collection(cn)
//   .doc("AttendeeList")
//   .collection("Attendees");

export default {
  name: "CellRendererActions",
  watch: {
    //  "params.data.IsPublished"() {
    //     debugger;
    //     //alert("watch:" + this.params.data.IsPublished);
    //     this.$store
    //       .dispatch("exhibitorManagement/updateStatus", {
    //         id: this.params.id,
    //         IsPublished: this.params.data.IsPublished,
    //       })
    //       .then(() => {
    //         this.showChangeStatusSuccess();
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //       });
    //   },
  },
  methods: {
    // editRecord () {
    //   this.$router.push(`event/exhibitor/add/${268}`).catch(() => {})
    // },
    editRecord(id) {
      console.log("catid" + id);
      this.$router
        .push({
          name: "instancetagsedit",
          params: {
            CatID: id,
          },
        })
        .catch(() => {});
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    deleteRecord() {
      console.log(this.params.id);
      /* Below two lines are just for demo purpose */
      // this.$store
      //   .dispatch("attendeeManagement/removeRecord", this.params.id)
      //   .then((res) => {
      //     if (res.status == 200) {
      //       this.$store.dispatch("attendeeManagement/fetchAttendees");
      //       this.showDeleteSuccess();
      //     }
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });

      //=========================================================================
      debugger;
      var cref2 = con.eventDB
        .collection("OA_UAT")
        .doc("TagCategories")
        .collection("CategoryList")
        .where("CatID", "==", this.params.id);

      // con.eventDB
      //   .collection("OA_UAT")
      //   .doc("TagCategories")
      //   .collection("CategoryList")
      //   .where("CatID", "==", this.params.id)
      //   .delete()
      //   .then(function () {
      //     console.log("Document successfully deleted!");
      //   })
      //   .catch(function (error) {
      //     console.error("Error removing document: ", error);
      //   });
      debugger;
      cref2.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          doc.ref
            .delete()
            .then(function () {
              // this.$vs.notify({
              //   color: "success",
              //   title: "Category Deleted",
              //   text: "The selected record was successfully deleted",
              // });
              alert("The selected record was successfully deleted");
            })
            .catch(function (error) {
              console.error("Error deleting data: ", error);
            });
        });
      });
      //============================================================
      //   var cref2 = con.eventDB
      //         .collection("OA_UAT")
      //         .doc("TagCategories")
      //         .collection("CategoryList")
      //         .where("CatID", "==", this.catID);
      // return new Promise((resolve, reject) => {
      //             var requestData = {
      //                 "instanceId": "OA_UAT",
      //                 "clientId": Session_Client_Id,
      //                 "eventId": Session_Event_Id.replace("E", ""),
      //                 "userId": userId
      //             };
      //             const headers = {
      //                 "Content-Type": "application/json"
      //                     //'MIME-Version': '1.0\r\n'
      //             }
      //             axios.post(DeleteAttendeeURL, requestData, { headers: headers })
      //                 .then((response) => {
      //                     debugger;
      //                     if (response.data.status == 0) {
      //                         attendeeRef.doc(userId).get().then(function(attendeedoc) {
      //                             attendeeRef.doc(userId).delete().then(function() {
      //                                 resolve({ status: 200, message: 'Rcord Deleted' })
      //                             })
      //                         })
      //                     } else {
      //                         reject({ status: 0, message: 'Rcord Not Deleted' })
      //                     }
      //                 })
      //                 .catch((error) => {
      //                     debugger;
      //                     //console.log(error)
      //                     reject(error)
      //                 })
      // }

      //===========================================================

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Category Deleted",
        text: "The selected record was successfully deleted",
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully",
      });
    },
  },
};
</script>
